export var categoryToUrlId = function(category) {
    var _category_url_id;
    return {
        id: (_category_url_id = category === null || category === void 0 ? void 0 : category.url_id) !== null && _category_url_id !== void 0 ? _category_url_id : ""
    };
};
